import React from 'react'
import '../styles/HeaderDownSection/headerDownSection.css'; 

function HeaderDownSection() {
  return (
    <div className='headerDownSection'>
      <div className='headerDownSection-inner'>
        <div className='up'>
            <div className='left'>
                
            </div>
            <div className='right'>
                <h5>We can help you to boost engagement with your visitors by ensuring that people have access to the information that they. A business concept is a statement that describes the reach and reason of existence of a given business idea.</h5>
            </div>
        </div>
        <div className='down'>
            <div className='left'>
                <h2>BUSINESS</h2>
                <h1>SOLUTIONS</h1>
            </div>
            <div className='right'>
                <div className='left-inner'>
                    <h1>01</h1>
                    <h3>EASY TO USE TOOLS</h3>
                    <h5>Sample text. Click to select the text box. Click again or double click to start editing the text.</h5>
                </div>
                <div className='right-inner'>
                    <h1>02</h1>
                    <h3>SPECIAL DISCOUNTS</h3>
                    <h5>Sample text. Click to select the text box. Click again or double click to start editing the text.</h5>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderDownSection
